var _filter, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAuto = function SvgAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 32,
    viewBox: "0 -0.5 67 32",
    enableBackground: "new 0 -0.5 67 32",
    xmlSpace: "preserve"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    width: "114.1%",
    height: "127.6%",
    id: "Auto_svg__a",
    filterUnits: "objectBoundingBox",
    y: "-6.9%",
    x: "-4.7%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    result: "shadowSpreadOuter1",
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    dx: 2,
    result: "shadowOffsetOuter1",
    "in": "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "shadowBlurOuter1",
    "in": "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    result: "shadowMatrixOuter1",
    "in": "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)",
    filter: "url(#Auto_svg__a)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.558 25a5.5 5.5 0 1 0 11.002-.002A5.5 5.5 0 0 0 44.558 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.292 15.978c-4.603-2.294-10.271-3.927-16.533-5.047C37.678 2.372 27.668 2.5 27.668 2.5c-7.275 0-13.609 2.522-16.955 6.521-.279.02-.561-.005-.828-.005H.561C.033 9.017 0 9.208 0 9.733V20.57c0 4.21 3.02 7.841 7.229 7.841H8.25V25a7.5 7.5 0 0 1 7.501-7.5A7.498 7.498 0 0 1 23.25 25v3.41h19.308V25c0-4.144 3.357-7.5 7.5-7.5 4.142 0 7.5 3.356 7.5 7.5v2.906l.623-.051c1.939-.204 3.396-.454 4.387-.617 1.039-.17 1.432-.852 1.432-1.904v-7.622c0-1.052-.768-1.265-1.708-1.734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 25a5.5 5.5 0 1 0 11.002-.002A5.5 5.5 0 0 0 10.25 25"
  }))));
};
export default SvgAuto;